import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
} from "@mui/material";
import moment from "moment";

const CommonTable = ({
  columns = [],
  rows = [],
  pagination = {},
  onPageChange,
  loading = false,
  title = "",
  dateFormat = "DD MMM YYYY, hh:mm A",
  prepaid = false,
}) => {
  const { page = 1, limit = 10, total = 0, totalPages = 1 } = pagination;

  return (
    <Box sx={{ width: "100%" }}>
      {title && (
        <Typography
          variant="h6"
          sx={{ color: "white", mb: 1, fontWeight: "bold" }}
        >
          {title}
        </Typography>
      )}

      {/* Single unified box for table + pagination */}
      <TableContainer
        component={Paper}
        sx={{
          background: "rgba(255,255,255,0.05)",
          borderRadius: 2,
          overflow: "hidden",
        }}
      >
        <Table>
          <TableHead>
            <TableRow
              sx={{
                background: "linear-gradient(90deg, #0C6135 0%, #93D222 100%)",
              }}
            >
              {columns.map((col) => (
                <TableCell
                  key={col.id || col.label}
                  sx={{
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "14px",
                    borderBottom: "none",
                  }}
                  align={col.align || "left"}
                >
                  {col.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody sx={{ background: "#001642" }}>
            {loading ? (
              <TableRow>
                <TableCell
                  colSpan={columns.length}
                  sx={{ color: "white", textAlign: "center", py: 3 }}
                >
                  Loading...
                </TableCell>
              </TableRow>
            ) : rows.length === 0 ? (
              <TableRow>
                <TableCell
                  colSpan={columns.length}
                  sx={{ color: "white", textAlign: "center", py: 3 }}
                >
                  No Data Found
                </TableCell>
              </TableRow>
            ) : (
              rows.map((row, i) => (
                <TableRow
                  key={i}
                  sx={{
                    backgroundColor: "#001642",
                    "&:hover": { backgroundColor: "#002266" },
                  }}
                >
                  <TableCell
                    sx={{ color: "#FFFFFF", fontSize: "14px" }}
                    align="left"
                  >
                    {row?.updated_at
                      ? moment(row.updated_at).format(dateFormat)
                      : "-"}
                  </TableCell>

                  <TableCell
                    sx={{ color: "#FFFFFF", fontSize: "14px" }}
                    align="left"
                  >
                    {prepaid ? row?.vin : row?.container_no ?? "-"}
                  </TableCell>

                  <TableCell
                    sx={{ color: "#FFFFFF", fontSize: "14px" }}
                    align="left"
                  >
                    {prepaid ? row?.storage_fee ?? "-" : row?.vin_count ?? "-"}
                  </TableCell>
                  {prepaid && (
                    <>
                      <TableCell
                        sx={{ color: "#FFFFFF", fontSize: "14px" }}
                        align="left"
                      >
                        {row?.late_fee ?? "-"}
                      </TableCell>

                      <TableCell
                        sx={{
                          color: "#FFFFFF",
                          fontSize: "14px",
                          textTransform: "capitalize",
                        }}
                        align="left"
                      >
                        {row?.status ?? "-"}
                      </TableCell>

                      <TableCell
                        sx={{
                          color: "#FFFFFF",
                          fontSize: "14px",
                        }}
                        align="left"
                      >
                        {row?.comment_summary ?? "-"}
                      </TableCell>
                    </>
                  )}

                  <TableCell
                    sx={{ color: "#FFFFFF", fontSize: "14px" }}
                    align="left"
                  >
                    {prepaid ? row?.invoice_no : row?.invoices ?? "-"}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>

        {/* Pagination Footer inside same box */}
        <Box
          sx={{
            px: 2,
            py: 1.5,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#001642",
            borderTop: "1px solid #1a2b6d",
            borderRadius: "0 0 8px 8px",
          }}
        >
          <Typography sx={{ color: "white", fontSize: "13px" }}>
            Showing data{" "}
            {total > 0
              ? `${(page - 1) * limit + 1} to ${Math.min(page * limit, total)}`
              : 0}{" "}
            of {total} entries
          </Typography>

          <Pagination
            count={totalPages}
            page={page}
            onChange={onPageChange}
            shape="rounded"
            siblingCount={1}
            boundaryCount={1}
            sx={{
              "& .MuiPaginationItem-root": {
                color: "#fff",
                border: "1px solid #fff",
                backgroundColor: "transparent",
                minWidth: "32px",
                height: "32px",
                borderRadius: "6px",
              },
              "& .MuiPaginationItem-icon": {
                color: "#fff",
              },
              "& .MuiPaginationItem-previousNext": {
                border: "1px solid #fff",
              },
              "& .Mui-selected": {
                background: "#0C6135 !important",
                border: "1px solid #0C6135",
                color: "#fff !important",
                fontWeight: "bold",
              },
              "& .MuiPaginationItem-ellipsis": {
                color: "#fff",
              },
            }}
          />
        </Box>
      </TableContainer>
    </Box>
  );
};

export default CommonTable;
